import { render, staticRenderFns } from "./AboutService.vue?vue&type=template&id=16072b6c&scoped=true&"
import script from "./AboutService.vue?vue&type=script&lang=js&"
export * from "./AboutService.vue?vue&type=script&lang=js&"
import style0 from "./AboutService.vue?vue&type=style&index=0&id=16072b6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16072b6c",
  null
  
)

export default component.exports